import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = () => {
  const authToken = localStorage.getItem("token");

  return authToken ? <Outlet /> : <Navigate to="/" replace />;
};

export default ProtectedRoute;
